import { render } from "./AuthenticatedSchool.vue?vue&type=template&id=66305072&ts=true"
import script from "./AuthenticatedSchool.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedSchool.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__